import styles from './AppliedFilters.module.scss';

const AppliedFilters = ({ filters, onChange, selectedFilters, currency, isRU }) => {
	return (
		<div className={styles.container}>
			{filters.map(filter => {
				const { type } = filter;

				switch (type) {
					case 'range': {
						const { slug, min, max, name } = filter;
						let appliedMin = selectedFilters[slug]?.min ?? min;
						let appliedMax = selectedFilters[slug]?.max ?? max;
						const isVisible = +appliedMin !== +min || +appliedMax !== +max;

						if (isRU && Object.keys(currency).length) {
							appliedMin = (parseFloat(appliedMin) * currency.BYN.RUB).toFixed(0);
							appliedMax = (parseFloat(appliedMax) * currency.BYN.RUB).toFixed(0);
						}

						const reset = () => {
							const nextFilters = { ...selectedFilters };
							delete nextFilters[slug];
							if (onChange) onChange(nextFilters);
						};

						if (isVisible) {
							return (
								<button className={styles.item} key={slug} title={name} onClick={reset}>
									{appliedMin} - {appliedMax}
								</button>
							);
						}
					}
					case 'checkbox': {
						const { slug, name: filterName, options } = filter;
						const appliedOptions = selectedFilters[slug] || [];

						const reset = option => () => {
							const nextOptions = appliedOptions.filter(appliedOption => appliedOption !== option);
							const nextFilters = { ...selectedFilters };
							if (nextOptions.length > 0) {
								nextFilters[slug] = nextOptions;
							} else {
								delete nextFilters[slug];
							}

							if (onChange) onChange(nextFilters);
						};

						if (appliedOptions.length > 0) {
							return appliedOptions.map(appliedOption => {
								const optionTitle =
									options.find(option => option.value === appliedOption)?.name ?? '';

								if (optionTitle) {
									return (
										<button
											className={styles.item}
											key={`${slug}-${appliedOption}`}
											title={filterName}
											onClick={reset(appliedOption)}
										>
											{optionTitle}
										</button>
									);
								}
							});
						}
					}
					default:
						return null;
				}
			})}

			<button
				className={styles.reset}
				onClick={e => {
					e.stopPropagation();
					if (onChange) onChange({});
				}}
			>
				Очистить все
			</button>
		</div>
	);
};

export default AppliedFilters;
